import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';
import { SortDownIcon, SortIcon, SortUpIcon } from '../icon/solid';

const useStyles = makeStyles(({ colors, palette }: Theme) => createStyles({
  root: {
    fontSize: 16,
    marginLeft: '0.2em',
  },
  none: {
    color: colors.icon,
  },
  asc: {
    color: palette.filter.hover,
    marginTop: '4px',
  },
  desc: {
    color: palette.filter.hover,
    marginBottom: '4px',
  },
}), { name: 'SortingIcon' });

type Props = {
  asc?: boolean;
  desc?: boolean;
};

const SortingIcon = ({
  asc,
  desc,
}: Props) => {
  const classes = useStyles();

  if (asc) {
    return (
      <SortUpIcon className={clsx(classes.root, classes.asc)} />
    );
  }

  if (desc) {
    return (
      <SortDownIcon className={clsx(classes.root, classes.desc)} />
    );
  }

  return (
    <SortIcon className={clsx(classes.root, classes.none)} />
  );
};

export default SortingIcon;
